import { render, staticRenderFns } from "./StandingOrders.vue?vue&type=template&id=64dcdc9f&scoped=true&"
import script from "./StandingOrders.vue?vue&type=script&lang=js&"
export * from "./StandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./StandingOrders.vue?vue&type=style&index=0&id=64dcdc9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcdc9f",
  null
  
)

export default component.exports